export default "/catalog/_next/static/scripts/ResizeObserver.global.d840a26ea7a3d7efdf6706df4586ecbe.js";